'use strict';

var _ = require('lodash');
var angular = require('angular');
var DemandPostingService = function DemandPostingService($filter, dataRetrieverService) {
  function getProductGroupItems(contextData) {
    return _.map(contextData.classGroups, function (item) {
      return {
        id: item,
        label: item
      };
    });
  }
  function createOperation(contextData) {
    var shiftSwapItems = [{
      label: 'SHIFT',
      id: 'SHIFT'
    }, {
      label: 'SWAP',
      id: 'SWAP'
    }];
    var productGroupItems = getProductGroupItems(contextData);
    return {
      sourceProductGroup: {
        items: productGroupItems
      },
      shiftSwap: {
        selectedItem: shiftSwapItems[0],
        items: shiftSwapItems
      },
      adjAmount: {
        absoluteValue: 0,
        percentageValue: 0,
        enabled: true
      },
      targetProductGroup: {
        items: productGroupItems
      }
    };
  }
  function getDemandPostingType() {
    var postingTypes = [{
      label: 'One-to-One',
      id: '11'
    }, {
      label: 'One-to-Many',
      id: '1M'
    }, {
      label: 'Many-to-One',
      id: 'M1'
    }];
    var targetAdjTypes = [{
      label: 'Percentage',
      id: 'Percentage'
    }, {
      label: 'Absolute',
      id: 'Absolute'
    }];
    return {
      postingType: {
        selectedItem: postingTypes[0],
        items: postingTypes
      },
      targetAdjType: {
        selectedItem: targetAdjTypes[0],
        items: targetAdjTypes
      }
    };
  }
  function aggregate(items, dimension) {
    return _.reduce(items, function (result, item) {
      result.classGroup = item.classGroup;
      if (!dimension || dimension === 'regular') {
        result.demand += _.isFinite(item.regularRemainingDemandFC) ? item.regularRemainingDemandFC : 0;
      } else {
        result.demand += _.isFinite(item.mappedRemainingDemandFC) ? item.mappedRemainingDemandFC : 0;
      }
      return result;
    }, {
      demand: 0
    });
  }
  function pickFields(item) {
    return _.pick(item, ['classGroup', 'regularRemainingDemandFC', 'mappedRemainingDemandFC']);
  }
  function loadGridData(gridParams) {
    return dataRetrieverService.getDataRetriever(gridParams.screen, gridParams.mode).retrieveComponentData(gridParams.gridId);
  }
  function loadRealDemandData(contextData, dimension) {
    var gridParams = contextData && contextData.gridParams || {};
    return loadGridData(gridParams).then(function (data) {
      return _.chain(data).map(pickFields).groupBy('classGroup').map(function (item) {
        return aggregate(item, dimension);
      }).transform(function (result, item) {
        result[item.classGroup] = !_.isNaN(item.demand) ? item.demand : 0;
        return result;
      }, {}).value();
    });
  }
  function scrollToGrid(cssSelector) {
    var body = angular.element('html, body');
    var gridEl = body.find(cssSelector);
    if (gridEl.size() > 0) {
      var position = gridEl.position().top;
      body.animate({
        scrollTop: position
      });
    }
  }
  function scrollDown(cssSelector, isDenmandPostingShow) {
    if (!isDenmandPostingShow) {
      scrollToGrid(cssSelector);
    }
  }
  return {
    getProductGroupItems: getProductGroupItems,
    createOperation: createOperation,
    getDemandPostingType: getDemandPostingType,
    loadRealDemandData: loadRealDemandData,
    loadGridData: loadGridData,
    scrollDown: scrollDown
  };
};
DemandPostingService.$inject = ['$filter', 'DataRetrieverService'];
module.exports = DemandPostingService;